import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { smootherPause } from "./smoother";

gsap.registerPlugin(ScrollTrigger);

export const videoWithPopup = () => {
    const tl = gsap.timeline();
    const videoModal = document.querySelector('.video-modal');
    const video = videoModal.querySelector('video');

    const videoModule = document.querySelector('.video');
    const videoBtnLink = videoModule.querySelector('.video__link-btn');
    const videoText = videoModule.querySelector('.h1');
    const videoModuleLink = videoModule.querySelector('.video__module-btn');

    const loopVideo = document.querySelector('.video__looped video');

    videoModuleLink.addEventListener('click', () => {
        document.querySelector('body').classList.add('video-modal-active');
        smootherPause(true);
        var source = document.createElement('source');
        source.src = videoModuleLink.dataset.link;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.play();
        loopVideo.pause();
    })

    videoModal.querySelector('.video-modal__close').addEventListener('click', () => {
        document.querySelector('body').classList.remove('video-modal-active');
        smootherPause(false);
        video.pause();
        loopVideo.play();
    })

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' &&  document.querySelector('body').classList.contains('video-modal-active')) {
            document.querySelector('body').classList.remove('video-modal-active');
            smootherPause(false);
            video.pause();
            loopVideo.play();
        }
    });

    videoModal.querySelector('.video-modal__overlay').addEventListener('click', () => {
        document.querySelector('body').classList.remove('video-modal-active');
        smootherPause(false);
        video.pause();
        loopVideo.play();
    })

    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            tl.from(videoBtnLink, {
                scrollTrigger: {
                    trigger: videoBtnLink,
                    start: 'top +=120%',
                    end: 'top 90%',
                    scrub: true
                },
                y: '8rem'
            })
            .from(videoText, {
                scrollTrigger: {
                    trigger: videoText,
                    start: 'top 100%',
                    end: 'top 20%',
                    scrub: true
                },
                y: '8rem'
            })
            .from('.video__content figure', {
                scrollTrigger: {
                    trigger: videoText,
                    start: 'top 100%',
                    end: 'top 20%',
                    scrub: true
                },
                y: '8rem'
            })
            .from('.video__looped', {
                scrollTrigger: {
                    trigger: '.video__looped',
                    start: 'top 100%',
                    end: 'top 50%',
                    scrub: true
                },
                scale: .9
            })
        }
    )
}

export const removeVideo = () => {
    const videoModal = document.querySelector('.video-modal');
    const videoSource = videoModal.querySelector('video source');
    videoSource != null ? videoSource.remove() : '';
}
